var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9297 13.144H18.8704V15.676H18.9418C19.6293 14.4422 21.3113 13.144 23.8201 13.144C29.0358 13.144 30 16.3902 30 20.6132V29.2143H24.8486V21.5899C24.8486 19.7721 24.8111 17.4312 22.1702 17.4312C19.4882 17.4312 19.0775 19.4115 19.0775 21.4577V29.2143H13.9297V13.144Z",
    fill: "#0274B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00195 13.144H10.3587V29.2143H5.00195V13.144Z",
    fill: "#0274B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3585 8.68017C10.3583 9.39075 10.0758 10.0721 9.57317 10.5744C9.07055 11.0767 8.38897 11.3588 7.67838 11.3585C6.96779 11.3583 6.2864 11.0758 5.78411 10.5732C5.28182 10.0705 4.99976 9.38897 5 8.67838C5.00024 7.96779 5.28274 7.2864 5.78537 6.78411C6.03425 6.5354 6.32968 6.33814 6.65478 6.20361C6.97989 6.06907 7.32832 5.99988 7.68017 6C8.03201 6.00012 8.38039 6.06953 8.70541 6.20429C9.03043 6.33904 9.32573 6.5365 9.57444 6.78537C9.82315 7.03425 10.0204 7.32968 10.1549 7.65478C10.2895 7.97989 10.3587 8.32832 10.3585 8.68017Z",
    fill: "#0274B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.73cbaa0510d6da2b646179d5056e7ab0.svg";
export { ForwardRef as ReactComponent };